<template>
  <div class="step__range">
    <div v-if="units.length > 1" class="calculator__units">
      <div v-for="(unit, i) in units" :key="unit.name" class="unit" :class="{unit_active: i === activeUnitIndex}" @click="activeUnitIndex = i">
        {{unit.name}}
      </div>
    </div>

    <div class="range__value">
      <div class="value">{{Math.round(value * activeUnit.precision) / activeUnit.precision}}</div>
      <div class="unit">
        {{activeUnit.name}}
      </div>
    </div>

    <div class="slider__wrapper" @mousedown="startMoving" @mousemove="moveSlider" @mouseup="endMoving" @touchstart="startMoving" @touchmove="moveSlider" @mouseleave="endMoving">
      <div class="range__slider" :style="{left: rangeLeft + 'px'}">
        <div class="range__slides">
          <div v-for="n in slidesCount + 1" class="range__slide" :class="{
                    slide_long: Math.round((n - activeUnit.step) + minCorrected) % 10 === 0,
                    slide_active: Math.round(value * activeUnit.precision) / activeUnit.precision === Math.round((((n - activeUnit.step) * sliderStep) + minCorrected) * activeUnit.precision) / activeUnit.precision
                  }">
            <div v-show="Math.round((n - activeUnit.step) + minCorrected) % 10 === 0" class="slide__value">
              {{Math.round((((n - activeUnit.step) * sliderStep) + minCorrected) * activeUnit.precision) / activeUnit.precision}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "quiz-scale",

  props: ['units'],

  created() {
    this.value = Math.round((this.maxCorrected - this.minCorrected) / 2) + this.minCorrected;
  },

  data() {
    return {
      value: 0,
      activeUnitIndex: 0,
      stepWidth: 2,
      stepsHorizontalGap: 12,
      offsetSlides: 12,
      isPressed: false,
      cursorX: 0,
    };
  },

  computed: {
    sliderStep() {
      return this.activeUnit.step;
    },
    slidesCount() {
      return Math.ceil((this.maxCorrected - this.minCorrected) / this.activeUnit.step);
    },
    rangeLeft() {
      return -(((this.value - this.minCorrected) * (this.stepWidth + this.stepsHorizontalGap)) / this.activeUnit.step) + this.sliderOffset;
    },
    sliderOffset() {
      return (this.offsetSlides * (this.stepWidth + this.stepsHorizontalGap) - this.stepsHorizontalGap)
    },
    activeUnit() {
      return this.units[this.activeUnitIndex];
    },
    minCorrected() {
      return this.activeUnit.min;
    },
    maxCorrected() {
      return this.activeUnit.max;
    },
  },

  watch: {
    activeUnitIndex(newVal, oldVal) {
      this.validateInput(true, this.units[newVal].multiplier, this.units[oldVal].multiplier);
    },
    units: {
      handler(val) {
        const activeUn = val[0];
        this.value = Math.round((activeUn.max - activeUn.min) / 2) + activeUn.min;
        this.activeUnitIndex = 0;
      },
      deep: true,
    },
  },

  methods: {
    validateInput(unitsChange, newVal, oldVal) {
      if (unitsChange === true) {
        if (this.value) {
          this.value = Math.round(this.value * (newVal / oldVal));
        } else {
          return;
        }
      }

      if (this.value < this.minCorrected) {
        this.value = this.minCorrected;
      } else if (this.value > this.maxCorrected) {
        this.value = this.maxCorrected;
      }

      this.$emit("changeValue", this.value);
    },
    startMoving(e) {
      this.isPressed = true;

      if (e.targetTouches) {
        const rect = e.target.closest('.slider__wrapper').getBoundingClientRect();
        this.cursorX = e.targetTouches[0].pageX - rect.left;
      } else {
        this.cursorX = e.offsetX;
      }

      e.target.closest('.slider__wrapper').style.cursor = "grabbing";
    },
    moveSlider(e) {
      if (!this.isPressed) return;
      e.preventDefault();

      let difference = 0;
      let offsetX = 0;
      if (e.targetTouches) {
        const rect = e.target.closest('.slider__wrapper').getBoundingClientRect();
        offsetX = e.targetTouches[0].pageX - rect.left;
        difference = offsetX - this.cursorX;
      } else {
        difference = e.offsetX - this.cursorX;
        offsetX = e.offsetX;
      }

      const swipedSlides = Math.round(difference / (this.stepsHorizontalGap + this.stepWidth));

      if (this.value <= this.minCorrected) {
        if (swipedSlides <= -1) {
          this.value += this.sliderStep;
          this.cursorX = offsetX;
        }
      } else if (this.value >= this.maxCorrected) {
        if (swipedSlides >= 1) {
          this.value -= this.sliderStep;
          this.cursorX = offsetX;
        }
      } else {
        if (swipedSlides >= 1) {
          this.value -= this.sliderStep;
          this.cursorX = offsetX;
        } else if (swipedSlides <= -1) {
          this.value += this.sliderStep;
          this.cursorX = offsetX;
        }
      }

      this.$emit("changeValue", this.value);
    },
    endMoving(e) {
      this.isPressed = false;
      e.target.closest('.slider__wrapper').style.cursor = "";
    },
  },
}
</script>
